export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12594.3432db9c.jpg";